import { render } from "./WealthPgCalculator.vue?vue&type=template&id=0b81309e"
import script from "./WealthPgCalculator.vue?vue&type=script&lang=js"
export * from "./WealthPgCalculator.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__